import Module from 'components/100-book-challenge/Module'
import { Row, Col } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

interface Props {
	language?: 'english' | 'spanish'
}

export default function Modules({ language = 'english' }: Props) {
	const data = useStaticQuery<HundredBookChallengeQuery>(query)
		.allContentful100BookChallenge.edges.filter((edge) => {
			if (language === 'english') return !edge.node.language.toLowerCase().includes('spanish')
			else return edge.node.language.toLowerCase().includes('spanish')
		})
		.sort((a, b) => {
			const sortOrder1 = a.node.sortOrder
			const sortOrder2 = b.node.sortOrder
			if (sortOrder1 < sortOrder2) return -1
			if (sortOrder1 > sortOrder2) return 1
			else return 0
		})

	return (
		<Row>
			<Col>
				<Tabs selectedTabClassName="bg-gray-200 font-bold" className="mt-6 w-full">
					<TabList className="flex flex-wrap">
						{data.map(({ node }) => {
							return (
								<Tab key={node.id} className="flex-grow cursor-pointer rounded-t border p-3 text-center hover:bg-gray-200">
									{node.name}
								</Tab>
							)
						})}
					</TabList>
					{data.map(({ node }) => {
						return (
							<TabPanel key={node.id}>
								<Module data={node} language={language} showFrameworks />
							</TabPanel>
						)
					})}
				</Tabs>
			</Col>
		</Row>
	)
}

export interface HundredBookChallengeModule {
	id: string
	name: string
	language: 'English' | 'Spanish'
	framework: {
		updatedAt: string
		cover: {
			gatsbyImageData: IGatsbyImageData
		}
		document: {
			file: {
				url: string
			}
		}
	}
	leveledLibrary: {
		title: string
		id: string
		gatsbyImageData: IGatsbyImageData
	}[]
	sortOrder: number
}

interface HundredBookChallengeQueryNode {
	node: HundredBookChallengeModule
}

interface HundredBookChallengeQuery {
	allContentful100BookChallenge: {
		edges: HundredBookChallengeQueryNode[]
	}
}

const query = graphql`
	query {
		allContentful100BookChallenge {
			edges {
				node {
					id
					name
					language
					framework {
						updatedAt
						cover {
							gatsbyImageData
						}
						document {
							file {
								url
							}
						}
					}
					leveledLibrary {
						id
						title
						gatsbyImageData
					}
					sortOrder
				}
			}
		}
	}
`
